import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import ExpandMoreSharpIcon from '@mui/icons-material/ExpandMoreSharp';
import ExpandLessSharpIcon from '@mui/icons-material/ExpandLessSharp';
import Button from './Button';
export const Popupmenu = ({popupOptions,label,TriggerComponent=Button,triggerCompClass,onOptionSelect,...otherProps}) => {
  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <React.Fragment>
          <TriggerComponent variant="contained" className={`tma_popup_btn ${triggerCompClass}`} iconcomponent={popupState.isOpen ? ExpandLessSharpIcon:ExpandMoreSharpIcon} text={label} {...otherProps} {...bindTrigger(popupState)}>
          </TriggerComponent>
          <Menu {...bindMenu(popupState)} className='tma_popup_menu'>
            {
              popupOptions.map((option,index)=>{
                return (
                  <MenuItem key={index} disabled={option.isDisabled} onClick={(e)=>{
                    onOptionSelect && onOptionSelect(option);
                    popupState.close(e);
                  }}>{option.label}</MenuItem>
                )
              })
            }
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
}

export  {Menu}